import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { useGetMyAdherenceDetail } from '@services/useGetMyAdherenceDetail';
import { useParams } from 'react-router';
import { MyAdherenceDetail } from '@components/templates/myAccount/myAdherenceDetail';

export function MyAdherenceDetailPage() {
    const { request: requestMyAdherenceDetail } = useGetMyAdherenceDetail();
    const { uuid } = useParams();
    const { t } = useTranslation();

    useEffect(() => {
        requestMyAdherenceDetail({ uuid: uuid || '' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const translations = {
        title: t('my-adherence-detail-component.metatags.title'),
        description: t('my-adherence-detail-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myAdherenceDetail,
        index: false,
    });

    return <MyAdherenceDetail />;
}
